<div class="flex flex-col justify-between overflow-hidden bg-white h-full">
  <div class="flex flex-0 items-center h-18 px-4 md:px-6 border-b bg-gray-50 dark:bg-transparent">

    <!-- Back button -->
    <!-- <a class="md:-ml-2" mat-icon-button (click)="closeDrawer()">
      <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
    </a> -->

    <!-- Contact info -->
    <div class="flex items-center ml-2 lg:ml-0 mr-2 cursor-pointer">
      <div class="relative flex flex-0 items-center justify-center w-10 h-10">
        <div
          class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
          {{data?.title?.charAt(0)}}
        </div>
      </div>
      <div class="ml-4 text-lg font-medium leading-5 truncate">{{data?.title}}</div>
    </div>

    <button class="ml-auto" mat-icon-button [matMenuTriggerFor]="conversationHeaderMenu">
      <mat-icon [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
      <mat-menu #conversationHeaderMenu>
        <button mat-menu-item (click)="onMessageSelectionFlagChange()">
          <ng-container *ngIf="!enableMessageSelection">
            <mat-icon [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
            Select messages
          </ng-container>
          <ng-container *ngIf="enableMessageSelection">
            <mat-icon [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
            Unselect messages
          </ng-container>
        </button>
        <button mat-menu-item (click)="clearMessages()">
          <mat-icon [svgIcon]="'heroicons_outline:backspace'"></mat-icon>
          Clear messages
        </button>
      </mat-menu>
    </button>
  </div>


  <div class="conversation-container">
    <div class="flex overflow-y-auto flex-col-reverse conversation h-screen">
      <div class="flex flex-col flex-auto shrink p-6 bg-card dark:bg-transparent">
        <ng-container
          *ngFor="let conversation of conversations; let i = index; let first = first; let last = last; trackBy: trackByFn">

          <div class="flex flex-col pt-2 mt-1 message-bubble-container" [ngClass]="{'items-end': conversation?.isMine,
                           'items-start': !conversation?.isMine,
                           'bg-blue-200': conversation?.isSelected,
                           'mt-0.5': conversation?.image,
                           'pt-2 mt-1': !conversation?.image}" (click)="conversation?.isMine ? selectMessage(conversation) : null">

            <!-- Bubble -->
            <div class="relative max-w-3/4 pt-1 pb-1 pl-2 pr-5 rounded-lg" [ngClass]="{'bg-blue-500 text-blue-50': conversation?.isMine, 'w-60': conversation?.image || conversation?.audioUrl, 'pb-6': conversation?.image && !isImage(conversation?.image), 
                             'bg-gray-500 text-gray-50': !conversation?.isMine}">

              <!-- Speech bubble tail -->
              <ng-container *ngIf="last || conversations[i + 1]?.isMine !== conversation?.isMine">
                <div class="absolute bottom-0 w-3" [ngClass]="{'text-blue-500 -right-1 -mr-px mb-px': conversation?.isMine,
                                 'text-gray-500 -left-1 -ml-px mb-px -scale-x-1': !conversation?.isMine}">
                  <ng-container *ngTemplateOutlet="speechBubbleExtension"></ng-container>
                </div>
              </ng-container>

              <!-- Display sender's name above the message and audio if it's not mine -->
              <ng-container *ngIf="!conversation?.isMine && conversation?.sender_user_name">
                <div class="pb-2 font-bold">
                  {{conversation?.sender_user_name}}
                </div>
              </ng-container>

              <!-- Message -->
              <div *ngIf="conversation?.image && isImage(conversation?.image)">
                <img [src]="conversation?.image" alt="Conversation image">
              </div>
              <div *ngIf="!conversation.isEditing; else editTemplate" class="min-w-4 leading-5 message">
              <span>{{ conversation.message }}</span>
                <button *ngIf="conversation.isMine" [matMenuTriggerFor]="menu" aria-label="Conversation Options" class="options-button">
                    <mat-icon style="color: white;" class="small-icon">expand_more</mat-icon>
                </button>
              
              <!-- Options Menu -->
              <mat-menu #menu="matMenu">
                <button *ngIf="conversation.isMine && conversation?.message" mat-menu-item (click)="editMessage(conversation)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteMessage(conversation)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                  </button>
              </mat-menu>
            </div>      

              <div *ngIf="conversation?.audioUrl">
                <audio class="w-full"[src]="conversation.audioUrl" controls aria-label="Audio message"
                  (error)="handleAudioError()"></audio>
              </div>
              
              <div *ngIf="conversation?.image && !isImage(conversation?.image)">
                <a [href]="conversation?.image" class="file-link">
                  <svg *ngIf="isExcel(conversation?.image)" class=".file-link svg" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 48 48">
                    <path fill="#169154" d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"></path>
                    <path fill="#18482a" d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"></path>
                    <path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z"></path>
                    <path fill="#17472a" d="M14 24.005H29V33.055H14z"></path>
                    <g>
                      <path fill="#29c27f" d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"></path>
                      <path fill="#27663f" d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"></path>
                      <path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z"></path>
                      <path fill="#129652" d="M29 24.005H44V33.055H29z"></path>
                    </g>
                    <path fill="#0c7238" d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"></path>
                    <path fill="#fff" d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"></path>
                  </svg>
                  <svg *ngIf="isPdf(conversation?.image)" class=".file-link svg" height="30px" width="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 303.188 303.188" xml:space="preserve" fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 ">
                        </polygon>
                        <path style="fill:#FB3449;"
                          d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936 c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202 c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251 c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594 c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603 c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02 c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024 c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387 c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205 c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119 c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57 C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041 c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065 c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918 c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985 c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993 c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883 c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265 c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197 c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542 c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275 c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z">
                        </path>
                        <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 "></polygon>
                        <g>
                          <path style="fill:#A4A9AD;"
                            d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643 v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857 h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z">
                          </path>
                          <path style="fill:#A4A9AD;"
                            d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979 h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324 c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43 C160.841,257.523,161.76,254.028,161.76,249.324z">
                          </path>
                          <path style="fill:#A4A9AD;"
                            d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374 L196.579,273.871L196.579,273.871z">
                          </path>
                        </g>
                        <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 "></polygon>
                      </g>
                    </g>
                  </svg>
                  <span class="file-name">{{ getFileName(conversation?.image) }}</span>
                </a>
              </div>
            </div>

            <!-- Time -->
            <ng-container
              *ngIf="first || last || conversations[i + 1]?.isMine !== conversation?.isMine || conversations[i + 1]?.createdAt !== conversation?.createdAt">
              <div class="my-0.5 text-sm font-medium text-secondary"
                [ngClass]="{'mr-3': conversation?.isMine, 'ml-3': !conversation?.isMine}">
                {{conversation?.createdAt | date:'HH:mm'}}
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>



    <!-- Message field -->
    <div class="items-end border-t pt-2 bg-gray-50 dark:bg-transparent">
      <div class="flex" [ngClass]="{'display-waveform': isRecording}">
        <div *ngIf="!isRecording" class="flex items-center h-11 my-px">
          <div *ngIf="showEmojiPicker">
            <emoji-mart class="emoji-mart-container" set="google" (emojiClick)="addEmoji($event)"
              [showPreview]="false"></emoji-mart>
              <button (click)="closeEmojiPicker()">
                <mat-icon class="ml-4 mt-2">close</mat-icon>
              </button>
          </div>
          <button class="ml-2" mat-icon-button (click)="toggleEmojiPicker()">
            <mat-icon [svgIcon]="'heroicons_outline:face-smile'"></mat-icon>
          </button>
          <button mat-icon-button class="ml-0.5" (click)="attachment.click()">
            <mat-icon>add</mat-icon>
          </button>
          <input type="file" (change)="uploadAvatar(attachment.files)" class="hidden" multiple
            #attachment>
        </div>

        <button *ngIf="isRecording" class="ml-8" mat-icon-button (click)="removeVoice()">
          <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        </button>

        <mat-form-field *ngIf="!isRecording" class="h-12 fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full ml-4"
          subscriptSizing="dynamic">
          <textarea matInput cdkTextareaAutosize placeholder="Type a message" (keydown.enter)="sendMessage()"
            class="message" #messageInput></textarea>
        </mat-form-field>
        <div *ngIf="isRecording" class="waveform flex">
          <span *ngIf="isRecording" class="mx-2">{{ recordingTime }}</span>
          <div class="bar" *ngFor="let bar of bars; let i = index"
            [ngClass]="{'odd': i % 2 === 0, 'even': i % 2 !== 0}">
          </div>
        </div>

        <div class="flex items-center h-11 my-px ml-4">
          <!-- <span *ngIf="isRecording" class="mr-2">{{ recordingTime }}</span> -->
          <button *ngIf="messageInput?.nativeElement.value.trim() && !isRecording" (click)="sendMessage()"
            mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
          </button>
          <button *ngIf="!messageInput?.nativeElement.value.trim() && !isRecording" (click)="startRecording()"
            mat-icon-button>
            <mat-icon>mic</mat-icon>
          </button>
          <button *ngIf="!messageInput?.nativeElement.value.trim() && isRecording" (click)="stopRecording()"
            mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <mat-drawer-container class="containerposition">
    <mat-drawer #drawer mode="over" [opened]="showDrawer">
      <div class="close-button">
        <button mat-icon-button matTooltip="Close" (click)="closeDrawer()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="image-gallery" *ngIf="isImage(image);">
        <img [src]="image" alt="Gallery Image" />
      </div>
      <div *ngIf="!isImage(image)" class="no-preview-container">
        <div class="icon">
          <svg viewBox="0 0 88 110" height="110" width="88" preserveAspectRatio="xMidYMid meet">
            <title>preview-txt</title>
            <defs>
              <path d="M3 0h56.928a5 5 0 0 1 3.536 1.464l15.072 15.072A5 5 0 0 1 80 20.07V101a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z" id="a"></path>
            </defs>
            <g transform="translate(4 3)" fill="none" fill-rule="evenodd">
              <use fill="#000" filter="url(#filter-3)" xlink:href="#a"></use>
              <use fill="#FFF" xlink:href="#a"></use>
              <path stroke-opacity="0.08" stroke="#000"
                    d="M3-.5h56.929a5.5 5.5 0 0 1 3.889 1.61l15.071 15.072a5.5 5.5 0 0 1 1.611 3.89V101a3.5 3.5 0 0 1-3.5 3.5H3A3.5 3.5 0 0 1-.5 101V3A3.5 3.5 0 0 1 3-.5z"
                    fill="url(#linearGradient-1)"></path>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="28" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="33" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="38" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="43" width="40" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="53" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="58" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="63" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="68" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="73" width="52" height="2" rx="0.5"></rect>
                    <rect fill-opacity="0.2" fill="#000" x="13" y="78" width="27" height="2" rx="0.5"></rect>
                    <path d="M61.5.5v15a3 3 0 0 0 3 3h15" stroke-opacity="0.12" stroke="#000" fill="#FFF"></path>
                  </g>
          </svg>
        </div>
        <div class="text">
          <div class="preview-message">No preview available</div>
          <div class="file-info">8 kB - TXT</div>
        </div>
      </div>
      
      <div>
        <mat-form-field class="fuse-mat-dense mt-8 captionpadding" style="margin-right: 166px;" subscriptSizing="dynamic">
          <textarea matInput cdkTextareaAutosize placeholder="Type a message" (keydown.enter)="sendMessage()"
            class="message" #imageInput></textarea>
          <!-- <div *ngIf="showEmojiPicker">
              <emoji-mart class="emoji-mart-container" set="google" (emojiClick)="addEmoji($event)"
                [showPreview]="false"></emoji-mart>
            </div>
            <button class="ml-2" mat-icon-button (click)="toggleEmojiPicker()">
              <mat-icon [svgIcon]="'heroicons_outline:face-smile'"></mat-icon>
            </button> -->
        </mat-form-field>
        <!-- <mat-icon class="ml-4 cursor-pointer" (click)="sendMessage()" [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon> -->
      </div>
      <div class="close-button">
        <button mat-icon-button class="custom-icon-button" (click)="sendMessage()">
          <mat-icon style="color: white; " [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
        </button>
      </div>
    </mat-drawer>
  </mat-drawer-container>

  <mat-drawer-container class="containerposition">
    <mat-drawer #drawer mode="over" [opened]="editDrawer" style="width:-webkit-fill-available !important">
      
      <div class="edit-button border-b">
        <div class="edit-header mx-2 my-2">Edit message</div>
        <button class="mx-2"  matTooltip="Close" (click)="closeDrawer()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="image-gallery h-50" >
        
        <div class="px-2 text-sm">
          <span mattooltip="Status" class="mat-mdc-tooltip-trigger text-sm justify-center edit-message">
            {{editmessage}} </span>
        </div>
      </div>
      <div class="textarea-center mx-2 sm:mx-0">
        <mat-form-field class="fuse-mat-dense mt-8 captionpadding" subscriptSizing="dynamic">
          <textarea matInput cdkTextareaAutosize placeholder="Type a message" (keydown.enter)="sendMessage()"
            class="message" #editInput></textarea>
        </mat-form-field>
      </div>
        <!-- <mat-icon class="ml-4 cursor-pointer" (click)="sendMessage()" [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon> -->
      
        <div class="close-button">
          <button mat-icon-button class="custom-icon-button" (click)="sendMessage()">
            <mat-icon style="color: white; ">check</mat-icon>
          </button>
        </div>
      
    </mat-drawer>
  </mat-drawer-container>
</div>

<!-- Speech bubble tail SVG -->
<ng-template #speechBubbleExtension>
  <svg width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M1.01522827,0.516204834 C-8.83532715,54.3062744 61.7609863,70.5215302 64.8009949,64.3061218 C68.8074951,54.8859711 30.1663208,52.9997559 37.5036011,0.516204834 L1.01522827,0.516204834 Z"
        fill="currentColor" fill-rule="nonzero"></path>
    </g>
  </svg>
</ng-template>

<ng-template #audioTemplate>
  <div class="w-full flex flex-row add-edit-modal-header">
    <div>Microphone Access Error</div>
  </div>
  <div mat-dialog-content>
    <mat-label> It seems the microphone is turned off or access is denied. <b>Please enable
        the microphone to start recording.</b></mat-label>
  </div>
  <div mat-dialog-actions>
    <button mat-dialog-close mat-button color="primary" class="ml-auto">
      OK
    </button>
  </div>
</ng-template>